/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';
import { getIconNamePropType } from 'UIComponents/utils/propTypes/iconName';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
export default class _class extends Component {
  render() {
    const {
      children,
      className,
      name,
      onClick,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsxs(UIButton, {
      className: className,
      disabled: readOnly,
      onClick: onClick,
      use: "link",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        color: CALYPSO_DARK,
        name: name
      }), children]
    });
  }

}
_class.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  name: getIconNamePropType().isRequired,
  onClick: PropTypes.func,
  readOnly: PropTypes.bool
};
_class.defaultProps = {
  children: null,
  className: null,
  onClick: emptyFunction
};